import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import BlockIcon from '@mui/icons-material/Block'
import { Grid, Typography } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'

export const Unauthorized: FC = () => {
  const { t } = useTranslation()

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      sx={{ height: '100vh', width: '100%' }}
    >
      <CssBaseline />
      <BlockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
      <Typography variant="h4">403</Typography>
      <Typography variant="h6" sx={{ mt: 1 }}>
        {t('unauthorized.text')}
      </Typography>
    </Grid>
  )
}
